module.exports = __webpack_public_path__ + "img/pop-bg.93f99cfd.png";